import getDashedTitle from '@/utilities/getDashedTitle';

const getBranchName = (resourceId, resourceTitle, character = '_') => {
  const title = getDashedTitle(resourceTitle).slice(0, 100).trim().replaceAll('-', character);
  const gitName = `st-${resourceId}${character}${title}`;
  return gitName;
};

export default getBranchName;
